import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/program_subject`;

export const ACTION_TYPES = {
  FETCH_PROGRAMSUBJECT_LIST: 'PROGRAMSUBJECT/FETCH_PROGRAMSUBJECT_LIST',
  FETCH_PROGRAMSUBJECT: 'PROGRAMSUBJECT/FETCH_PROGRAMSUBJECT',
  CREATE_PROGRAMSUBJECT: 'PROGRAMSUBJECT/CREATE_PROGRAMSUBJECT',
  UPDATE_PROGRAMSUBJECT: 'PROGRAMSUBJECT/UPDATE_PROGRAMSUBJECT',
  DELETE_PROGRAMSUBJECT: 'PROGRAMSUBJECT/DELETE_PROGRAMSUBJECT',
  RESET: 'PROGRAMSUBJECT/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
};

// REDUCER
const programsubjectReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PROGRAMSUBJECT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PROGRAMSUBJECT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PROGRAMSUBJECT):
    case REQUEST(ACTION_TYPES.UPDATE_PROGRAMSUBJECT):
    case REQUEST(ACTION_TYPES.DELETE_PROGRAMSUBJECT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PROGRAMSUBJECT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PROGRAMSUBJECT):
    case FAILURE(ACTION_TYPES.CREATE_PROGRAMSUBJECT):
    case FAILURE(ACTION_TYPES.UPDATE_PROGRAMSUBJECT):
    case FAILURE(ACTION_TYPES.DELETE_PROGRAMSUBJECT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAMSUBJECT_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAMSUBJECT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PROGRAMSUBJECT):
    case SUCCESS(ACTION_TYPES.UPDATE_PROGRAMSUBJECT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PROGRAMSUBJECT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default programsubjectReducer;

// ACTIONS
export const getEntities = (idProgram, revisionNum) => ({
  type: ACTION_TYPES.FETCH_PROGRAMSUBJECT_LIST,
  payload: axios.get(`${apiUrl}?program_id=${idProgram}&program_revision_num=${revisionNum}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PROGRAMSUBJECT,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const deleteEntity = (id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PROGRAMSUBJECT,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { errorMessage: `Gagal hapus!`, successMessage: `Berhasil Hapus!` },
  });
  return result;
};

export const updateEntity = (id, entity) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PROGRAMSUBJECT,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { errorMessage: `Gagal Update!`, successMessage: `Berhasil Update!` },
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
